<script lang="ts" setup>
import { computed } from 'vue'

import { useAntdDesignTokens } from '@vben/hooks'
import { preferences, usePreferences } from '@vben/preferences'

import { App, ConfigProvider, theme } from 'ant-design-vue'

import { useMenuBadges } from '#/composables/business/use-menu-badges'
import { antdLocale } from '#/locales'

defineOptions({ name: 'App' })

useMenuBadges()

const { isDark } = usePreferences()

const { tokens } = useAntdDesignTokens()

const tokenTheme = computed(() => {
  const algorithm = isDark.value
    ? [theme.darkAlgorithm]
    : [theme.defaultAlgorithm]

  // antd 紧凑模式算法
  if (preferences.app.compact) {
    algorithm.push(theme.compactAlgorithm)
  }

  return {
    algorithm,
    token: tokens,
  }
})

function insertCssVarStyleTag(obj: Recordable, preifx = '') {
  const camelCaseToKebabCase = (str: string) =>
    str.replaceAll(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()

  function objToCssText(obj: object) {
    return Object.entries(obj).reduce((ret, [key, value]) => {
      if (typeof value === 'string') {
        ret += `--${preifx}-${camelCaseToKebabCase(key)}: ${value};`
      }
      return ret
    }, '')
  }

  const styleElement = document.createElement('style')
  styleElement.dataset.prefix = preifx
  styleElement.innerHTML = `:root { ${objToCssText(obj)} }`
  document.head.append(styleElement)

  return styleElement
}

const { token } = theme.useToken()

watchEffect(() => {
  const prefix = 'antd'
  const styleElement = document.querySelector(`style[data-prefix="${prefix}"]`)
  if (styleElement) {
    styleElement.remove()
  }
  insertCssVarStyleTag(token.value, prefix)
})
</script>

<template>
  <ConfigProvider :locale="antdLocale" :theme="tokenTheme">
    <App>
      <RouterView />
    </App>
  </ConfigProvider>
</template>
